import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PHBHPFeaturePackageSOPManagementService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'app-sop',
  templateUrl: './sop.component.html',
  styleUrls: ['./sop.component.css']
})
export class SopComponent implements OnInit {

  newSOPId:number;

  constructor(
    public layoutService: PHBHPLayoutPackageService, 
    private service: PHBHPFeaturePackageSOPManagementService, 
    private router:Router,
    public appConfig: AppConfig) { }

  ngOnInit() {
  }
  
  childData(data) {
    switch (data.key) {
      case 'edit':
        this.router.navigate(["/sop/edit/" + data.val]);
        break;
      case 'view':
        this.router.navigate(["/sop/view/" + data.val]);
        break;
      case 'duplicate':
        this.router.navigate([`/sop/duplicate/${data.val.sopId}`]);
        break;
      case 'duplicateVersion':
        this.service.duplicateSOP(data.val.sopId, data.val.userId, data.val.sopVersionNo, (data.val.institutionId || 0), data.val.isMaster).subscribe((newSOPId: number) => {
          this.newSOPId = newSOPId;
          // this.layoutService.showSuccess(this.layoutService.translateText('SOP_MANAGEMENT.SOP_COPIED_SUCCESSFULLY'));
          this.router.navigate([`/sop/edit/${newSOPId}/0`]);
        });
        break;
      case 'duplicateNationVersion':
        this.service.duplicateSOP(data.val.sopId, data.val.userId, data.val.sopVersionNo, (data.val.institutionId || 0), data.val.countryId).subscribe((newSOPId: number) => {
          this.newSOPId = newSOPId;
          // this.layoutService.showSuccess(this.layoutService.translateText('SOP_MANAGEMENT.SOP_COPIED_SUCCESSFULLY'));
          this.router.navigate([`/sop/edit/${newSOPId}/0`]);
        });
        break;
      case 'editVersion':
        this.router.navigate([`/sop/edit/${data.val.sopId}/${data.val.sopVersionNo}`]);
        break;
      case 'viewVersion':
        this.router.navigate([`/sop/view/${data.val.sopId}/${data.val.sopVersionNo}`]);
        break;
      case 'url':
        this.router.navigate([data.val]);
        break;
    }
  }
}
